import axiosapi from "./axiosAPI";

// Get All EmploymentSectors
export const getAllEmploymentSectors = async (
    setEmploymentSectors,
    setFetcherror,
    options
) => {
    
    const newoptions = options ? options : {};
    
	try{
		const res =await axiosapi.get("/employmentsectors",newoptions);
        setEmploymentSectors(res.data.data ? res.data.data : {});

	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch EmploymentSectors");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch EmploymentSectors");
		}
		
	}
	
};



// Get One EmploymentSector
export const getOneEmploymentSector = async (
    pkid,
    setFetcherror,  
    setEmploymentSector
    
)=>{
	try{
		const res =await axiosapi.get(`/employmentsectors/${pkid}`);
        setEmploymentSector(res.data.body);
       
	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch EmploymentSector");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch EmploymentSector");
		}
		
	}
	
};


// Create New EmploymentSector
export const createEmploymentSector = async (
    e,
    employmentSector,
    setEmploymentSector,
    setFetcherror,
    handleAllToasts

) => {

    e.preventDefault();

    if (!employmentSector ) {
        handleAllToasts(2, "No EmploymentSector Provided"); 
            return; 
        }

    const PushItem = {
            name: employmentSector,
        };

    try{
        await axiosapi.patch("/employmentsectors/",PushItem );
        setEmploymentSector("");
        handleAllToasts(1, "EmploymentSector Created Successfully");
    }
    catch(err){
        if(err.response){
            //Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Could Not Create New EmploymentSector");
            handleAllToasts(2, "Could Not update The EmploymentSector");
            
            
        }else{
            //No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Could Not Create New EmploymentSector");
            handleAllToasts(2, "Could Not update The EmploymentSector");
            
        }
        
    }
    
}


// Edit Existing EmploymentSector

export const editEmploymentSector = async (
    e,
    employmentSectorpkid,
    employmentSector,
    setEmploymentSector,
    setFetcherror,
    handleAllToasts
              
        ) => {
            e.preventDefault();

            if (!employmentSector) {
                handleAllToasts(2, "No EmploymentSector Name Provided"); 
                    return;  
                }

            const PushItem = {

                    id:employmentSectorpkid,
                    name: employmentSector,
                };

            try{
                await axiosapi.patch("/employmentsectors/",PushItem );
                setEmploymentSector("");
                handleAllToasts(1, "EmploymentSector Updated Successfully");
            }
            catch(err){
                if(err.response){
                    //Error Obtained from Backend not in 200
                    console.log(err.response.data);
                    console.log(err.response.status);
                    console.log(err.response.headers);
                    setFetcherror("Could Not Update EmploymentSector");
                    handleAllToasts(2, "Could Not Update EmploymentSector");
                    
                    
                }else{
                    //No response Obtained from the server.
                    console.log(`Error: ${err.message}`);
                    setFetcherror("Could Not Update EmploymentSector");
                    handleAllToasts(2, "Could Not Update EmploymentSector");
                    
                }
                
            }
            
};



// Delete Existing EmploymentSector.

export const deleteEmploymentSector = async (
    employmentSectorpkid,
    setEmploymentSectors,
    setFetcherror,
    handleAllToasts
)=>{
    try {
        const res = await axiosapi.delete(`/employmentsectors/${employmentSectorpkid}`);
        let finalData = res.data.message;
        getAllEmploymentSectors(setEmploymentSectors, setFetcherror);
        handleAllToasts(1, "EmploymentSector Deleted Successfully");
        console.log("Deleted:", finalData);
    }
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
			console.log(err.response.data);
			console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Delete EmploymentSector");
            handleAllToasts(2,"Error: Could Not Delete EmploymentSector");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Delete EmploymentSector");
            handleAllToasts(2,"Error: Could Not Delete EmploymentSector");
		}
		
	}
	
};